import { render, staticRenderFns } from "./DespesaTotal.vue?vue&type=template&id=5d159490"
import script from "./DespesaTotal.vue?vue&type=script&lang=js"
export * from "./DespesaTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports